import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "events-calendar-filter-drawer__close-trigger" }
const _hoisted_2 = { class: "events-calendar-filter-drawer__fields-wrapper" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "events-calendar-filter-drawer__fields-section" }
const _hoisted_5 = { class: "events-calendar-filter-drawer__footer-container" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]

import { computed, onBeforeUnmount, onMounted, reactive, ref, watch } from 'vue';
import { CloseOutlined } from '@ant-design/icons-vue';
import {
  Col as ACol,
  ConfigProvider as AConfigProvider,
  DatePicker as ADatePicker,
  Drawer as ADrawer,
  Form as AForm,
  FormItem as AFormItem,
  Row as ARow,
  Select as ASelect,
  Space as ASpace,
} from 'ant-design-vue';
import type { Dayjs } from 'dayjs';
import ruRU from 'ant-design-vue/es/locale/ru_RU';
import { submitNewsFilters } from '../../utils/news-filters';
import { EVENTS_CALENDAR_FILTER_SUBMIT_OPTIONS } from './events-calendar-filter-config';
import {
  applyEventsCalendarFilterDraft,
  draftsEqual,
  getEventsCalendarScope,
  getSelectOptions,
  readEventsCalendarFilterDraft,
  type EventsCalendarFilterDraft,
} from './sync-filters';


export default /*@__PURE__*/_defineComponent({
  __name: 'EventsCalendarFilterDrawer',
  props: {
    open: { type: Boolean }
  },
  emits: ["update:open", "applied"],
  setup(__props: any, { emit: __emit }) {

const ARangePicker = ADatePicker.RangePicker;

const ICONS_BASE =
  process.env.NODE_ENV === 'development'
    ? '/assets/images/icons'
    : '/local/templates/dist/assets/images/icons';

const props = __props;

const emit = __emit;

const formatOptions = computed(() => getSelectOptions('activity_format'));
const typeOptions = computed(() => getSelectOptions('activity_type'));

const applied = ref<EventsCalendarFilterDraft>({
  activityFormat: '',
  activityType: '',
  dateRange: null,
});

const draft = reactive<{
  activityFormat: string;
  activityType: string;
  dateRange: [Dayjs, Dayjs] | null;
}>({
  activityFormat: '',
  activityType: '',
  dateRange: null,
});

const viewportWidth = ref(window.innerWidth);

const drawerWidth = computed(() => (viewportWidth.value <= 576 ? '100%' : 800));

const hasDraftValues = computed(() =>
  Boolean(draft.activityFormat || draft.activityType || draft.dateRange),
);

const hasChanges = computed(
  () =>
    draftsEqual(
      {
        activityFormat: draft.activityFormat,
        activityType: draft.activityType,
        dateRange: draft.dateRange,
      },
      applied.value,
    ) === false,
);

const isResetDisabled = computed(() => !hasDraftValues.value);
const isApplyDisabled = computed(() => !hasChanges.value);

function syncDraftFromDom(): void {
  const current = readEventsCalendarFilterDraft(getEventsCalendarScope());

  draft.activityFormat = current.activityFormat;
  draft.activityType = current.activityType;
  draft.dateRange = current.dateRange;
  applied.value = {
    activityFormat: current.activityFormat,
    activityType: current.activityType,
    dateRange: current.dateRange,
  };
}

function handleResize(): void {
  viewportWidth.value = window.innerWidth;
}

watch(
  () => props.open,
  (isOpen) => {
    if (!isOpen) return;
    syncDraftFromDom();
  },
);

function handleReset(): void {
  draft.activityFormat = '';
  draft.activityType = '';
  draft.dateRange = null;
}

async function handleApply(): Promise<void> {
  const scope = getEventsCalendarScope();
  const nextDraft: EventsCalendarFilterDraft = {
    activityFormat: draft.activityFormat,
    activityType: draft.activityType,
    dateRange: draft.dateRange,
  };

  applyEventsCalendarFilterDraft(scope, nextDraft, { silent: true });
  await submitNewsFilters(scope, EVENTS_CALENDAR_FILTER_SUBMIT_OPTIONS);

  applied.value = nextDraft;
  emit('applied');
  emit('update:open', false);
}

onMounted(() => {
  syncDraftFromDom();
  window.addEventListener('resize', handleResize);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ADrawer), {
    width: drawerWidth.value,
    open: __props.open,
    class: "events-calendar-filter-drawer",
    "body-style": { paddingBottom: '24px' },
    "footer-style": { textAlign: 'center', padding: '16px 48px 32px 48px' },
    onClose: _cache[3] || (_cache[3] = ($event: any) => (emit('update:open', false)))
  }, {
    title: _withCtx(() => [...(_cache[4] || (_cache[4] = [
      _createElementVNode("div", { class: "events-calendar-filter-drawer__header-shell" }, [
        _createElementVNode("div", { class: "events-calendar-filter-drawer__header-overline" }, "Фильтр")
      ], -1)
    ]))]),
    closeIcon: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_unref(CloseOutlined))
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-outline btn-medium",
          disabled: isResetDisabled.value,
          onClick: handleReset
        }, " Сбросить ", 8, _hoisted_6),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary btn-medium",
          disabled: isApplyDisabled.value,
          onClick: handleApply
        }, " Применить ", 8, _hoisted_7)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(AForm), {
        layout: "vertical",
        class: "events-calendar-filter-drawer__form"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(AFormItem), {
              label: "Формат мероприятия",
              class: "stc-ant-field-skin"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ASelect), {
                  value: draft.activityFormat,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((draft.activityFormat) = $event)),
                  options: formatOptions.value,
                  placeholder: "Все форматы"
                }, null, 8, ["value", "options"])
              ]),
              _: 1
            }),
            _createVNode(_unref(AFormItem), {
              label: "Период проведения",
              class: "stc-ant-field-skin"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(AConfigProvider), { locale: _unref(ruRU) }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ARangePicker), {
                      value: draft.dateRange,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((draft.dateRange) = $event)),
                      style: {"width":"100%"},
                      format: "DD.MM.YYYY",
                      placeholder: ['дд.мм.гггг', 'дд.мм.гггг']
                    }, {
                      separator: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                        _createTextVNode("-", -1)
                      ]))]),
                      suffixIcon: _withCtx(() => [
                        _createElementVNode("img", {
                          src: `${_unref(ICONS_BASE)}/range-picker-icon.svg`,
                          alt: ""
                        }, null, 8, _hoisted_3)
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["locale"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(AFormItem), {
              label: "Тип мероприятия",
              class: "stc-ant-field-skin"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ASelect), {
                  value: draft.activityType,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((draft.activityType) = $event)),
                  options: typeOptions.value,
                  placeholder: "Все типы"
                }, null, 8, ["value", "options"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["width", "open"]))
}
}

})